var $c7b7ce8f7656df86$exports = {};
$c7b7ce8f7656df86$exports = {
    "more": `\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{639}\u{646}\u{627}\u{635}\u{631}`
};


export {$c7b7ce8f7656df86$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
